module.exports = __webpack_public_path__ + "static/media/parque-metropolitano.f72a8d24.png";